import { put, call, select, takeEvery } from 'redux-saga/effects'
import { RootReducer } from '../redux/rootReducer'
import apiCall from '../helpers/apiCall'
import {
  FETCH_LESSONS,
  FETCH_LESSONS_FAIL,
  FETCH_LESSONS_SUCCESS,
  FetchLessonsActionType
} from '../redux/lessonsReducer'
import { Lesson } from '../types'

function* FetchLessonsFlow(action: FetchLessonsActionType): Generator<any, void, any> {
  const TTL = 1000 * 60 * 1 // 1 minute
  try {
    const lastFetchedAt = yield select((state: RootReducer) => state.lessonsReducer[action.payload.type].lastFetchedAt)
    if (lastFetchedAt && Date.now() - new Date(lastFetchedAt).getTime() < TTL) {
      return
    }
    const response: Lesson[] = yield call(apiCall, {
      endpoint: '/tutors/lessons',
      method: 'GET',
      params: { status: action.payload.type }
    })
    yield put(FETCH_LESSONS_SUCCESS({ type: action.payload.type, lessons: response }))
  } catch (error) {
    yield put(FETCH_LESSONS_FAIL())
    console.log(error)
  }
}

export default function* FetchLessonsSaga(): Generator<any, void, any> {
  yield takeEvery([FETCH_LESSONS], FetchLessonsFlow)
}
